/**
 * Opções estáticas dos filtros do Monitoramento de Dispositivos.
 *
 * Centralizadas para serem validadas por teste de regressão:
 * nenhuma opção pode ter value vazio, pois o Select (Radix) reserva
 * a string vazia para limpar a seleção e mostrar o placeholder.
 */
import { FILTER_ALL } from "../../lib/selectFilters";

export const PERIODS = [
  { value: "7d", label: "Últimos 7 dias" },
  { value: "30d", label: "Últimos 30 dias" },
  { value: "90d", label: "Últimos 90 dias" },
  { value: "12m", label: "Últimos 12 meses" },
];

export const TYPE_OPTIONS = [
  { value: FILTER_ALL, label: "Todos os tipos" },
  { value: "porta_isca", label: "Porta-isca" },
  { value: "trex", label: "T-REX" },
  { value: "armadilha_luminosa", label: "Armadilha luminosa" },
  { value: "armadilha_biologica", label: "Armadilha biológica" },
  { value: "armadilha_mecanica", label: "Armadilha mecânica" },
  { value: "placa_cola", label: "Placa de cola" },
  { value: "catrex", label: "Catrex" },
  { value: "outro", label: "Outro" },
];
